module.exports = __webpack_public_path__ + "static/media/gold.3368d67d.png";